// Generic task status enum to represent three different states common
// to network requests and other similar tasks
const TaskStatus = Object.freeze({
  PENDING: Symbol('pending'),
  SUCCESS: Symbol('success'),
  FAILURE: Symbol('failure')
})

export default TaskStatus
